import { Button, Card, Center, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import { signIn } from '../lib/auth';

function GoogleLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 118 120" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#4285F4"
        d="M117.6,61.364C117.6,57.109 117.218,53.018 116.509,49.091L60,49.091L60,72.3L92.291,72.3C90.9,79.8 86.673,86.155 80.318,90.409L80.318,105.464L99.709,105.464C111.055,95.018 117.6,79.636 117.6,61.364Z"
      />
      <path
        fill="#34A853"
        d="M60,120C76.2,120 89.782,114.627 99.709,105.464L80.318,90.409C74.945,94.009 68.073,96.136 60,96.136C44.373,96.136 31.145,85.582 26.427,71.4L6.382,71.4L6.382,86.945C16.255,106.555 36.545,120 60,120Z"
      />
      <path
        fill="#FBBC05"
        d="M26.427,71.4C25.227,67.8 24.545,63.955 24.545,60C24.545,56.045 25.227,52.2 26.427,48.6L26.427,33.055L6.382,33.055C2.318,41.155 0,50.318 0,60C0,69.682 2.318,78.845 6.382,86.945L26.427,71.4Z"
      />
      <path
        fill="#EA4335"
        d="M60,23.864C68.809,23.864 76.718,26.891 82.936,32.836L100.145,15.627C89.755,5.945 76.173,0 60,0C36.545,0 16.255,13.445 6.382,33.055L26.427,48.6C31.145,34.418 44.373,23.864 60,23.864Z"
      />
    </svg>
  );
}

export default function Login() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background:
          'radial-gradient(1000px 600px at 20% 10%, rgba(20, 184, 166, 0.15) 0%, transparent 60%),' +
          'radial-gradient(900px 500px at 80% 90%, rgba(99, 102, 241, 0.15) 0%, transparent 60%)',
      }}
    >
      <Center style={{ minHeight: '100vh' }} p="md">
        <Card
          withBorder
          padding="xl"
          radius="lg"
          shadow="md"
          style={{
            maxWidth: 420,
            width: '100%',
            background:
              'linear-gradient(180deg, rgba(20, 184, 166, 0.06) 0%, rgba(99, 102, 241, 0.04) 100%)',
            borderTop: '3px solid',
            borderImage:
              'linear-gradient(90deg, var(--mantine-color-teal-5), var(--mantine-color-indigo-5)) 1',
          }}
        >
          <Stack gap="xl" align="center">
            <Group gap={10} align="center">
              <ThemeIcon
                size={44}
                radius="xl"
                variant="gradient"
                gradient={{ from: 'teal', to: 'indigo', deg: 45 }}
              >
                <IconSettings size={26} stroke={2} />
              </ThemeIcon>
              <Text
                fw={300}
                size="28px"
                ff="'Inter', system-ui, sans-serif"
                style={{ letterSpacing: '-0.02em', lineHeight: 1 }}
                variant="gradient"
                gradient={{ from: 'teal', to: 'indigo', deg: 45 }}
              >
                Parts
                <Text span fw={800} inherit>
                  Hub
                </Text>
              </Text>
            </Group>

            <Text c="dimmed" size="sm" ta="center">
              Master heavy-duty truck parts database
            </Text>

            <Button
              variant="default"
              fullWidth
              size="md"
              leftSection={<GoogleLogo />}
              onClick={() => signIn()}
            >
              Sign in with Google
            </Button>
          </Stack>
        </Card>
      </Center>
    </div>
  );
}
